/* MedSchoolBro — custom bundle builder page
   Discount engine mirrors the Shopify Function (bundles.js): maximising search
   over preset combinations, each selected product used at most once, leftovers
   priced by the fallback tiers. Display only — the Function enforces. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 989px)';
  var STORE_KEY = 'msbb:v1';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format, trim) {
    cents = Math.round(cents || 0);
    var fmt = format || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function d(n, prec, th, dec) {
      var neg = n < 0;
      var parts = (Math.abs(n) / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return (neg ? '-' : '') + (parts[1] ? parts[0] + dec + parts[1] : parts[0]);
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = d(cents, 2, ' ', ','); break;
      default: v = d(cents, 2, ',', '.');
    }
    if (trim && cents % 100 === 0) v = v.replace(/[.,]00$/, '');
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* Bottom edge of whatever fixed/sticky header is pinned to the top. */
  function headerBottom(root) {
    var el = document.elementFromPoint(window.innerWidth / 2, 2);
    while (el && el !== document.body && el !== document.documentElement) {
      if (root.contains(el)) return 0;
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') {
        var r = el.getBoundingClientRect();
        return r.top <= 2 ? Math.max(0, Math.round(r.bottom)) : 0;
      }
      el = el.parentElement;
    }
    return 0;
  }

  /* Height of the theme's sticky header, even before it is stuck.
     Ignores drawers/modals (fixed, full-height) and anything in the builder. */
  function stickyHeaderHeight(root) {
    var els = document.querySelectorAll('sticky-header, .header-section, .section-header, #shopify-section-header, .shopify-section-group-header-group, header');
    var h = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (root && root.contains(el)) continue;
      for (var d = 0; el && d < 3; d++, el = el.parentElement) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
        var r = el.getBoundingClientRect();
        if (cs.display !== 'none' && cs.visibility !== 'hidden' &&
            (parseFloat(cs.top) || 0) <= 1 &&
            r.height > 0 && r.height < window.innerHeight * 0.35) {
          h = Math.max(h, r.height);
        }
        break;
      }
    }
    return Math.round(h);
  }

  function Builder(root) {
    this.root = root;
    this.fmt = root.dataset.moneyFormat || '${{amount}}';

    var cfg = {};
    try {
      cfg = JSON.parse(root.querySelector('[data-msbb-config]').textContent);
    } catch (e) {
      console.error('[msbb] Invalid pricing config', e);
    }
    this.usd = cfg.usd || {};
    this.tierBasis = (cfg.tiers && cfg.tiers.basis) || 'count';
    this.tiers = ((cfg.tiers && cfg.tiers.levels) || []).slice().sort(function (a, b) { return a.min - b.min; });
    this.rawPresets = cfg.presets || [];
    this.suggest = cfg.suggest || {};
    this.tierPills = cfg.tierPills || [];

    this.products = {};
    this.order = [];
    this.selected = [];
    this.open = false;
    this.headerH = 0;
    this.mq = window.matchMedia(MOBILE);

    this.panel = root.querySelector('[data-panel]');
    this.head = root.querySelector('[data-panel-toggle]');
    this.countEl = root.querySelector('[data-count]');
    this.emptyEl = root.querySelector('[data-empty]');
    this.groupsEl = root.querySelector('[data-groups]');
    this.summaryEl = root.querySelector('[data-summary]');
    this.nudgeEl = root.querySelector('[data-nudge]');
    this.atc = root.querySelector('[data-atc]');
    this.atcLabel = root.querySelector('[data-atc-label]');
    this.atcNow = root.querySelector('[data-atc-now]');
    this.atcSave = root.querySelector('[data-atc-save]');
    this.errorEl = root.querySelector('[data-error]');
    this.scrim = root.querySelector('[data-scrim]');

    this.watchCartDrawer();
    this.collect();
    this.buildPresets();
    this.bindNav();
    this.bindPanel();
    this.bindAtc();
    this.restore();
    this.render(true);
  }

  var B = Builder.prototype;

  /* Hide the mobile bundle dock while the cart drawer is open so it never
     covers the drawer's checkout button. */
  B.watchCartDrawer = function () {
    var cd = document.getElementById('CartDrawer');
    if (!cd || !window.MutationObserver) return;
    var self = this;
    var sync = function () {
      var open = !cd.hasAttribute('hidden');
      document.documentElement.classList.toggle('msbb-cart-open', open);
      if (open && self.open) self.setOpen(false);
    };
    new MutationObserver(sync).observe(cd, { attributes: true, attributeFilter: ['hidden', 'open', 'class'] });
    sync();
  };

  B.money = function (c, trim) { return formatMoney(c, this.fmt, trim); };

  /* ---------- products ---------- */

  B.collect = function () {
    var self = this;
    this.root.querySelectorAll('[data-card]').forEach(function (card) {
      var h = card.dataset.handle;
      var p = self.products[h];
      if (!p) {
        p = {
          handle: h,
          title: card.dataset.title,
          thumb: card.dataset.thumb,
          ref: parseInt(card.dataset.ref, 10) || 0,
          usd: self.usd[h] != null ? Math.round(self.usd[h] * 100) : null,
          available: card.dataset.available === 'true',
          cards: []
        };
        self.products[h] = p;
        self.order.push(h);
        self.readVariant(p, card);
      }
      p.cards.push(card);

      var sel = card.querySelector('[data-variant]');
      if (sel) {
        sel.value = p.variantId;
        sel.addEventListener('change', function () { self.setVariant(p, sel.value); });
      }
      var btn = card.querySelector('[data-toggle]');
      if (btn) btn.addEventListener('click', function () { self.toggle(h); });
    });
  };

  B.readVariant = function (p, card) {
    var sel = card.querySelector('[data-variant]');
    if (sel) {
      var o = sel.options[sel.selectedIndex];
      p.variantId = o.value;
      p.price = parseInt(o.dataset.price, 10) || 0;
      p.compare = parseInt(o.dataset.compare, 10) || 0;
      p.variantTitle = o.dataset.title || '';
      p.variantImage = o.dataset.image || '';
    } else {
      p.variantId = card.dataset.vid;
      p.price = parseInt(card.dataset.price, 10) || 0;
      p.compare = parseInt(card.dataset.compare, 10) || 0;
      p.variantTitle = '';
      p.variantImage = '';
    }
  };

  B.setVariant = function (p, id) {
    var opt = null;
    p.cards.forEach(function (c) {
      var s = c.querySelector('[data-variant]');
      if (!s) return;
      s.value = id;
      if (!opt) opt = s.options[s.selectedIndex];
    });
    if (!opt || opt.disabled) return;
    p.variantId = opt.value;
    p.price = parseInt(opt.dataset.price, 10) || 0;
    p.compare = parseInt(opt.dataset.compare, 10) || 0;
    p.variantTitle = opt.dataset.title || '';
    p.variantImage = opt.dataset.image || '';
    this.paintCard(p);
    this.render();
  };

  B.paintCard = function (p) {
    var html = '<span class="msbb-now">' + this.money(p.price) + '</span>';
    if (p.compare > p.price) html += '<s class="msbb-was">' + this.money(p.compare) + '</s>';
    p.cards.forEach(function (c) {
      var el = c.querySelector('[data-card-price]');
      if (el) el.innerHTML = html;
      if (p.variantImage) {
        var img = c.querySelector('[data-card-img]');
        if (img) { img.removeAttribute('srcset'); img.src = p.variantImage; }
      }
    });
  };

  B.toggle = function (h) {
    var p = this.products[h];
    if (!p) return;
    var i = this.selected.indexOf(h);
    if (i > -1) {
      this.selected.splice(i, 1);
    } else {
      if (!p.available) return;
      this.selected.push(h);
      this.bump();
    }
    this.render();
  };

  B.bump = function () {
    var el = this.countEl;
    if (!el) return;
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  };

  /* ---------- discount engine ---------- */

  /* Preset amount off in the shopper's currency, same method as the PDP:
     ratio = local list total / USD list total, bundle price rounded to the
     nearest whole unit. Reference = each product's highest variant price. */
  /* A single USMLE flashcard set (variant title without "+") is a different
     item for bundle purposes: "<handle>:single". */
  B.keyFor = function (h) {
    var p = this.products[h];
    var t = p && p.variantTitle ? p.variantTitle.toLowerCase() : '';
    if (!t || t.indexOf('all') > -1) return h;
    var plus = (t.match(/\+/g) || []).length;
    if (plus === 0 && this.usd[h + ':single'] != null) return h + ':single';
    if (plus === 1 && this.usd[h + ':two'] != null) return h + ':two';
    return h;
  };
  function realHandle(k) { return String(k).split(':')[0]; }

  B.buildPresets = function () {
    var P = this.products;
    var U = this.usd;
    /* usd/ref for a key; virtual keys reuse the real product's currency ratio */
    function usdOf(k) {
      var h = realHandle(k);
      if (k !== h) return U[k] != null ? Math.round(U[k] * 100) : null;
      return P[h] ? P[h].usd : null;
    }
    function refOf(k) {
      var h = realHandle(k);
      if (!P[h]) return 0;
      if (k === h) return P[h].ref;
      return P[h].usd ? Math.round(P[h].ref * usdOf(k) / P[h].usd) : 0;
    }
    var refSum = 0, usdSum = 0;
    this.order.forEach(function (h) {
      if (P[h].usd) { refSum += P[h].ref; usdSum += P[h].usd; }
    });
    this.ratio = usdSum ? refSum / usdSum : 1;

    this.presets = this.rawPresets.map(function (r) {
      var ok = r.items.every(function (k) { return P[realHandle(k)] && usdOf(k) != null; });
      if (!ok) return null;
      var usdTotal = 0, localRef = 0;
      r.items.forEach(function (k) { usdTotal += usdOf(k); localRef += refOf(k); });
      var ratio = localRef / usdTotal;
      var bundleLocal = Math.round(((usdTotal - r.off * 100) * ratio) / 100) * 100;
      /* other currencies: Shopify converts the USD discount at the exchange
         rate, capped by the same % of the local price */
      var cur = window.Shopify && window.Shopify.currency;
      var rate = cur ? parseFloat(cur.rate) : 1;
      if (rate && Math.abs(rate - 1) > 0.0001) {
        var offLocal = Math.min(Math.round(r.off * 100 * rate), Math.round(r.off * 100 * localRef / usdTotal));
        return {
          name: r.name, items: r.items, x: r.x || [], need: r.need || null,
          real: r.items.map(realHandle), xreal: (r.x || []).map(realHandle),
          off: Math.max(0, offLocal)
        };
      }
      return {
        name: r.name, items: r.items, x: r.x || [], need: r.need || null,
        real: r.items.map(realHandle), xreal: (r.x || []).map(realHandle),
        off: Math.max(0, localRef - bundleLocal)
      };
    }).filter(Boolean).sort(function (a, b) {
      return b.items.length - a.items.length || b.off - a.off;
    });
  };

  /* left  = items the % is applied to
     count = cart item count that decides the tier (whole cart) */
  B.tierFor = function (left, count) {
    if (!left.length) return { pct: 0, amount: 0, count: 0 };
    var P = this.products;
    var basis;
    if (this.tierBasis === 'spend') {
      var sub = left.reduce(function (a, h) { return a + P[h].price; }, 0);
      basis = sub / this.ratio / 100;
    } else {
      basis = count != null ? count : left.length;
    }
    var pct = 0;
    this.tiers.forEach(function (t) { if (basis >= t.min) pct = t.pct; });
    var amount = left.reduce(function (a, h) { return a + Math.round(P[h].price * pct / 100); }, 0);
    return { pct: pct, amount: amount, count: left.length };
  };

  B.solve = function (handles) {
    var self = this;
    var idx = {};
    handles.forEach(function (h, i) { idx[self.keyFor(h)] = i; });

    var P = this.products;
    var cands = this.presets.filter(function (p) {
      if (p.need) {
        for (var nh in p.need) {
          var vt = (P[nh] && P[nh].variantTitle || '').toLowerCase();
          if (vt.indexOf(String(p.need[nh]).toLowerCase()) === -1) return false;
        }
      }
      return p.items.every(function (h) { return idx[h] !== undefined; });
    }).map(function (p) {
      var mask = 0;
      p.items.forEach(function (h) { mask |= 1 << idx[h]; });
      return { preset: p, mask: mask };
    });

    /* Mirrors the native discounts: Buy X Get Y presets and the custom
       tier discount don't combine. Either presets apply (other items stay
       full price) or the tier % applies to every item, counted across the
       whole cart. Shopify takes whichever saves more. */
    var best = { discount: -1 };
    var chosen = [];
    (function dfs(k, used, acc) {
      if (k === cands.length) {
        if (acc > best.discount) {
          var left = handles.filter(function (h, i) { return !(used & (1 << i)); });
          best = { discount: acc, presets: chosen.slice(), leftovers: left, tier: { pct: 0, amount: 0, count: left.length } };
        }
        return;
      }
      var c = cands[k];
      if (!(c.mask & used)) {
        chosen.push(c.preset);
        dfs(k + 1, used | c.mask, acc + c.preset.off);
        chosen.pop();
      }
      dfs(k + 1, used, acc);
    })(0, 0, 0);

    var tierAll = self.tierFor(handles);
    if (tierAll.amount > best.discount) {
      best = { discount: tierAll.amount, presets: [], leftovers: handles.slice(), tier: tierAll };
    }
    return best;
  };

  /* ---------- render ---------- */

  B.render = function (initial) {
    var self = this;
    var P = this.products;
    var sel = this.selected;
    var res = this.solve(sel);
    var subtotal = sel.reduce(function (a, h) { return a + P[h].price; }, 0);
    var total = subtotal - res.discount;

    /* what each unselected product would add */
    var unlocks = {};
    var tierPct = {};
    var cands = [];
    if (sel.length) {
      this.order.forEach(function (h) {
        if (sel.indexOf(h) > -1 || !P[h].available) return;
        var r2 = self.solve(sel.concat(h));
        var inc = r2.discount - res.discount;
        if (inc <= 0) return;
        var unlock = null;
        r2.presets.forEach(function (p) { if (!unlock && p.real.indexOf(h) > -1) unlock = p; });
        var entry = { handle: h, inc: inc, unlock: unlock, rank: self.rankFor(h) };
        if (unlock) unlocks[h] = entry;
        else if (r2.tier && r2.tier.pct > 0 && self.tierPills.indexOf(h) > -1) tierPct[h] = r2.tier.pct;
        cands.push(entry);
      });
    }
    /* recommendation: the item that unlocks the biggest preset saving
       (popularity breaks ties); else the most popular companion */
    var byInc = function (a, b) { return b.inc - a.inc || a.rank - b.rank; };
    var byRank = function (a, b) { return a.rank - b.rank || b.inc - a.inc; };
    var pick = cands.filter(function (c) { return c.unlock; }).sort(byInc)[0] ||
      cands.filter(function (c) { return c.rank < Infinity; }).sort(byRank)[0] || null;

    /* cards */
    this.order.forEach(function (h) {
      var p = P[h];
      var on = sel.indexOf(h) > -1;
      p.cards.forEach(function (c) {
        c.classList.toggle('is-selected', on);
        var b = c.querySelector('[data-toggle]');
        if (b && p.available) {
          var u = !on && unlocks[h];
          var tp = !on && !u && tierPct[h];
          b.classList.toggle('is-deal', !!(u || tp));
          if (u) {
            b.innerHTML = '<span>Add</span><span class="msbb-pill">Save ' + self.money(u.inc, true) + '</span>';
          } else if (tp) {
            b.innerHTML = '<span>Add</span><span class="msbb-pill">Save ' + tp + '%</span>';
          } else {
            b.textContent = on ? 'Remove' : 'Add';
          }
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      });
    });

    /* count */
    this.countEl.textContent = sel.length + (sel.length === 1 ? ' item' : ' items');

    /* groups */
    this.emptyEl.hidden = sel.length > 0;
    /* per-line discount for display: preset amount split by price share
       (remainder on the last line), tier % per line */
    var alloc = {};
    res.presets.forEach(function (p) {
      /* Buy X Get Y: the X item(s) stay full price, the discount is spread
         over the Y items by price share */
      var ys = p.real.filter(function (h) { return p.xreal.indexOf(h) === -1; });
      if (!ys.length) ys = p.real.slice();
      var sum = ys.reduce(function (a, h) { return a + P[h].price; }, 0);
      var left = p.off;
      ys.forEach(function (h, i) {
        var d = i === ys.length - 1 ? left : Math.round(p.off * P[h].price / sum);
        d = Math.max(0, Math.min(d, P[h].price));
        alloc[h] = d;
        left -= d;
      });
    });
    res.leftovers.forEach(function (h) {
      alloc[h] = Math.round(P[h].price * res.tier.pct / 100);
    });
    this.alloc = alloc;

    var html = '';
    res.presets.forEach(function (p) {
      html += self.groupHtml(p.name, 'Save ' + self.money(p.off, true), p.real, 'is-deal');
    });
    if (res.leftovers.length) {
      if (res.tier.pct > 0) {
        html += self.groupHtml(
          'Custom bundle: ' + res.tier.pct + '% off',
          'Save ' + self.money(res.tier.amount, true),
          res.leftovers, 'is-deal'
        );
      } else {
        html += self.groupHtml(
          'Add more to save',
          '', res.leftovers, 'is-none'
        );
      }
    }
    this.groupsEl.innerHTML = html;

    /* summary */
    if (res.discount > 0) {
      var names = res.presets.map(function (p) { return p.name; });
      if (res.tier.pct > 0) names.push('Custom bundle ' + res.tier.pct + '% off');
      this.summaryEl.innerHTML = '<span class="msbb-sum-deal">' + esc(names.join(' + ')) + ' applied</span>';
      this.summaryEl.hidden = false;
    } else {
      this.summaryEl.hidden = true;
      this.summaryEl.innerHTML = '';
    }

    var n = pick;
    if (n) {
      var np = P[n.handle];
      this.nudgeEl.innerHTML =
        '<p class="msbb-nudge-label">Recommended</p><div class="msbb-nudge-card"><div class="msbb-nudge-top">' +
        (np.thumb ? '<img class="msbb-nudge-img" src="' + esc(np.thumb) + '" alt="" width="52" height="52">' : '') +
        '<p class="msbb-nudge-text">Add <b>' + esc(np.title) + '</b> to save more</p>' +
        '<span class="msbb-pill">Save ' + this.money(n.inc, true) + '</span></div>' +
        '<button type="button" class="msbb-nudge-btn" data-nudge-add="' + esc(n.handle) + '">' +
        '<span>Add</span><span class="msbb-nudge-now">' + this.money(Math.max(0, np.price - n.inc)) + '</span>' +
        '<s class="msbb-nudge-was">' + this.money(np.price) + '</s></button></div>';
      this.nudgeEl.hidden = false;
    } else {
      this.nudgeEl.hidden = true;
      this.nudgeEl.innerHTML = '';
    }

    /* add to cart */
    this.atc.disabled = sel.length === 0;
    this.atcLabel.textContent = 'Add To Cart';
    this.atcNow.textContent = sel.length ? this.money(total) : '';
    this.atcSave.textContent = res.discount > 0 ? 'Saved ' + this.money(res.discount, true) : '';
    this.atcSave.hidden = !(res.discount > 0);
    if (this.errorEl) this.errorEl.textContent = '';

    if (!initial) this.save();
    this.measureDock();
  };

  /* lower = more popular companion of something already in the bundle */
  B.rankFor = function (h) {
    var best = Infinity, S = this.suggest;
    this.selected.forEach(function (s) {
      var i = (S[s] || []).indexOf(h);
      if (i > -1 && i < best) best = i;
    });
    return best;
  };

  B.priceHtml = function (h) {
    var p = this.products[h];
    var d = (this.alloc && this.alloc[h]) || 0;
    if (d <= 0) return '<span class="msbb-row-price">' + this.money(p.price) + '</span>';
    return '<span class="msbb-row-price is-sale"><s>' + this.money(p.price) + '</s><b>' +
      this.money(p.price - d) + '</b></span>';
  };

  B.groupHtml = function (name, save, handles, cls) {
    var self = this;
    var P = this.products;
    var rows = handles.map(function (h) {
      var p = P[h];
      return '<div class="msbb-row">' +
        (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="msbb-row-ph"></span>') +
        '<div class="msbb-row-main"><p class="msbb-row-title">' + esc(p.title) + '</p>' +
        (p.variantTitle ? '<p class="msbb-row-var">' + esc(p.variantTitle) + '</p>' : '') +
        '</div>' + self.priceHtml(h) +
        '<button type="button" class="msbb-row-x" data-remove="' + esc(h) + '" aria-label="Remove ' + esc(p.title) + '">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button></div>';
    }).join('');
    return '<div class="msbb-group ' + cls + '"><div class="msbb-group-head">' +
      '<span class="msbb-group-name">' + esc(name) + '</span>' +
      (save ? '<span class="msbb-group-save">' + save + '</span>' : '') +
      '</div>' + rows + '</div>';
  };

  /* ---------- persistence + deep links ---------- */
  /* ?bundle=handle,handle:variantId  (handy for ad links) */

  /* Restores the session bundle, then adds anything passed in
     ?bundle=handle:variantId,... (PDP "Build Your Own Bundle" link, ads).
     The param is removed from the URL afterwards so a reload or a later
     removal isn't undone. */
  B.restore = function () {
    var fromSession = [], fromUrl = [];
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (raw) fromSession = JSON.parse(raw) || [];
    } catch (e) {}
    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('bundle');
      if (q) {
        fromUrl = q.split(',');
        params.delete('bundle');
        var qs = params.toString();
        history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      }
    } catch (e) {}

    var self = this;
    var added = [];
    fromSession.concat(fromUrl).forEach(function (entry) {
      var parts = String(entry).trim().split(':');
      var p = self.products[parts[0]];
      if (!p || !p.available) return;
      if (parts[1]) {
        var s = p.cards[0].querySelector('[data-variant]');
        var o = s && s.querySelector('option[value="' + parts[1] + '"]');
        if (o && !o.disabled) {
          p.cards.forEach(function (c) {
            var ss = c.querySelector('[data-variant]');
            if (ss) ss.value = parts[1];
          });
          self.readVariant(p, p.cards[0]);
          self.paintCard(p);
        }
      }
      if (self.selected.indexOf(p.handle) === -1) self.selected.push(p.handle);
      if (fromUrl.indexOf(entry) > -1) added.push(p);
    });

    /* came from a PDP: persist it and bring it into view */
    if (added.length) {
      this.save();
      var card = added[0].cards[0];
      setTimeout(function () {
        if (!card) return;
        var y = card.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: Math.max(0, y), behavior: 'auto' });
      }, 60);
    }
  };

  B.save = function () {
    var P = this.products;
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(this.selected.map(function (h) {
        return h + ':' + P[h].variantId;
      })));
    } catch (e) {}
  };

  /* ---------- category nav ---------- */

  B.bindNav = function () {
    var self = this;
    this.chips = [].slice.call(this.root.querySelectorAll('[data-chip]'));
    this.cols = this.chips.map(function (c) { return document.getElementById(c.dataset.chip); });

    this.headerH = stickyHeaderHeight(this.root);

    this.chips.forEach(function (chip, i) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        self.scrollToCol(i);
      });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var hb = headerBottom(self.root);
        if (hb > self.headerH) self.headerH = hb;
        self.root.style.setProperty('--msbb-top', hb + 'px');
        self.activeChip(hb);
        self.sizePanel();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  };

  B.scrollToCol = function (i) {
    var t = this.cols[i];
    if (!t) return;
    var self = this;
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function targetY() {
      var off = Math.max(stickyHeaderHeight(self.root), headerBottom(self.root));
      return Math.max(0, Math.round(t.getBoundingClientRect().top + window.pageYOffset - off - 12));
    }
    window.scrollTo({ top: targetY(), behavior: smooth ? 'smooth' : 'auto' });
    /* second pass: header may stick/resize or content may shift mid-scroll */
    clearTimeout(this.navFix);
    this.navFix = setTimeout(function () {
      var y = targetY();
      if (Math.abs(y - window.pageYOffset) > 4) window.scrollTo({ top: y, behavior: 'auto' });
    }, smooth ? 750 : 50);
  };

  /* Desktop: fit the sidebar to the visible viewport so the foot
     (recommendation + Add to cart) is never below the fold. */
  B.sizePanel = function () {
    if (this.mq.matches) { this.panel.style.height = ''; return; }
    var top = parseFloat(this.root.style.getPropertyValue('--msbb-top')) || 0;
    var start = Math.max(this.panel.getBoundingClientRect().top, top);
    this.panel.style.height = Math.max(360, window.innerHeight - start) + 'px';
  };

  B.activeChip = function (hb) {
    var line = hb + 80;
    var active = -1;
    this.cols.forEach(function (c, i) {
      if (c && c.getBoundingClientRect().top <= line) active = i;
    });
    this.chips.forEach(function (c, i) { c.classList.toggle('is-active', i === active); });
  };

  /* ---------- panel (sidebar on desktop, bottom sheet on mobile) ---------- */

  B.bindPanel = function () {
    var self = this;

    this.head.addEventListener('click', function () {
      if (self.mq.matches) self.setOpen(!self.open);
    });
    this.scrim.addEventListener('click', function () { self.setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.open) self.setOpen(false);
    });

    this.root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) { self.toggle(rm.dataset.remove); return; }
      var add = e.target.closest('[data-nudge-add]');
      if (add) self.toggle(add.dataset.nudgeAdd);
    });

    var onMq = function () {
      if (!self.mq.matches) self.setOpen(false);
      self.sizePanel();
      self.measureDock();
    };
    if (this.mq.addEventListener) this.mq.addEventListener('change', onMq);
    else if (this.mq.addListener) this.mq.addListener(onMq);

    if (window.ResizeObserver) {
      new ResizeObserver(function () { self.measureDock(); }).observe(this.panel);
    }
  };

  B.setOpen = function (o) {
    this.open = !!o;
    this.panel.classList.toggle('is-open', this.open);
    this.head.setAttribute('aria-expanded', this.open ? 'true' : 'false');
    this.scrim.hidden = !this.open;
    document.documentElement.classList.toggle('msbb-lock', this.open);
  };

  /* reserve space under the page so the docked bar never covers the footer */
  B.measureDock = function () {
    var docked = this.mq.matches;
    document.body.classList.toggle('msbb-docked', docked);
    if (docked && !this.open) {
      document.documentElement.style.setProperty('--msbb-dock', this.panel.offsetHeight + 'px');
    }
  };

  /* ---------- add to cart ---------- */

  B.bindAtc = function () {
    var self = this;
    this.atc.addEventListener('click', function () { self.addToCart(); });
    /* bfcache restore: never leave the button stuck on "Adding…" */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        self.atc.classList.remove('is-busy');
        self.render(true);
      }
    });
  };

  B.addToCart = function () {
    var self = this;
    var P = this.products;
    if (!this.selected.length) return;

    var items = this.selected.map(function (h) {
      return { id: Number(P[h].variantId), quantity: 1 };
    });

    this.atc.classList.add('is-busy');
    this.atcLabel.textContent = 'Adding\u2026';

    var sections = [];
    try {
      if (window.FoxTheme && FoxTheme.cartDrawer && FoxTheme.cartDrawer.getSectionsToRender) {
        sections = FoxTheme.cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}

    var body = { items: items };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    fetch((((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function (payload) {
        self.atc.classList.remove('is-busy');
        self.atcLabel.textContent = 'Added';
        self.setOpen(false);

        if (typeof window.msbAfterAdd === 'function') window.msbAfterAdd(payload);
        else window.location.href = (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart');
        setTimeout(function () { self.render(true); }, 1500);
      })
      .catch(function (err) {
        self.atc.classList.remove('is-busy');
        self.render(true);
        self.errorEl.textContent = (err && err.description) || 'Could not add to cart. Please try again.';
      });
  };

  /* ---------- boot ---------- */

  function init(scope) {
    (scope || document).querySelectorAll('[data-msbb]').forEach(function (el) {
      if (el.dataset.msbbReady) return;
      el.dataset.msbbReady = '1';
      new Builder(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
